import { SolicitudServicioDetail } from "@/services/service-requests.service";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

interface Props {
  detail: SolicitudServicioDetail | null;
}

dayjs.extend(utc);
dayjs.extend(timezone);

export const SamplingRequestRejectMotive = ({ detail }: Props) => {
  return (
    <>
      <Flex alignItems="center" gap="30px">
        <Text fontWeight={700}>Motivo de rechazo</Text>
      </Flex>

      <Flex
        flexDir="column"
        paddingX="24px"
        borderLeft={`4px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text
          fontWeight={400}
          css={{
            "@media (max-width: 1350px) and (min-width: 1272px)": {
              fontSize: "12px",
            },
            "@media (max-width: 1414px) and (min-width: 1351px)": {
              fontSize: "14px",
            },
            "@media (max-width: 1590px) and (min-width: 1415px)": {
              fontSize: "14px",
            },
            "@media (max-width: 1696px) and (min-width: 1591px)": {
              fontSize: "16px",
            },
            "@media (max-width: 1900px)": {
              fontSize: "16px",
            },
          }}
        >
          {detail?.motivoRechazo}
        </Text>
        <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
          {detail?.fechaRechazo
            ? dayjs
                .utc(detail.fechaRechazo)
                .tz("America/Argentina/Buenos_Aires")
                .format("DD/MM/YYYY - HH:mm")
            : "-"}{" "}
          - {detail?.usuarioRechazo ?? "-"}
        </Text>
      </Flex>
    </>
  );
};
